<template>
    <div>
      <img v-if="material.pc_tp_img" class="vote_report_xfc" @click="sup_tc" v-lazy="img_url + material.pc_tp_img">
    </div>
  </template>
  
  <script>
      import { auto } from "@popperjs/core";
      import layer from "layui-layer";
      import { mapState } from "vuex";
      export default {
          name:'Violation',
          data() {
            return {
              img:'/supended/img/xfc.png'
            }
          },
          computed:{
            ...mapState([
              'getClient',
              'material'
            ])
          },
          methods:{
            sup_tc(){
              var vote_tc = $('.vote_tc')
              var LayIndex = layer.open({
                  type: 1,
                  content: vote_tc,
                  anim: false,
                  fixed: true,
                  shade: 0.6,
                  title: 0,
                  scrollbar: true,
                  shadeClose: true,
                  isOutAnim: false,
                  area: [auto, auto],
                  success:function(){
                      
                  }
              });
            }
          },
          
      }
  </script>
  
  <style scoped>
      .vote_report_xfc{
        position: fixed;
        left: 0;
        z-index: 99;
        cursor: pointer;
        width: 10%;
        top: 50%;
      }
  </style>